import BindMonitoringServicePositioningDevicesModal from './bind-monitoring-service-positioning-devices-modal.vue'
export default BindMonitoringServicePositioningDevicesModal
